import React from "react";
import rightArrow from "../../assets/images/right-arrow.png";
import { Link } from "gatsby";

const ServiceCard = ({ number, title, description, isIndexPage, url = "", isLink = false, state }) => (
  <div>
    <div className="flex items-center gap-5">
      <p className="lg:text-[64px] sm:text-[44px] text-4xl font-bold text-blue-300">{number}</p>
      {isLink ? (
        <Link to={url} state={{ to: state }}>
          <h3 className="justify-center px-5 lg:text-[22px] text-xl font-medium text-gray-900 border-l border-l-gray-400 lg:leading-[29px] leading-tight">
            {title.split("<br />").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index !== title.split("<br />").length - 1 && <br />}
              </React.Fragment>
            ))}
          </h3>
        </Link>
      ) : (
        <h3 className="justify-center px-5 lg:text-[22px] text-xl font-medium text-gray-900 border-l border-l-gray-400 lg:leading-[29px] leading-tight">
          {title.split("<br />").map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {index !== title.split("<br />").length - 1 && <br />}
            </React.Fragment>
          ))}
        </h3>
      )}
    </div>
    <p className="mt-5 text-base  text-gray-700 font-normal leading-relaxed">{description}</p>
    <button
      className={`flex items-center gap-2.5 self-start mt-4 text-base font-medium leading-normal text-gray-900  ${
        isIndexPage ? "" : "hidden"
      }`}
    >
      Learn More
      <img loading="lazy" src={rightArrow} className="mt-0.5 h-2.5 w-5" alt="right arrow" />
    </button>
  </div>
);

const Services = ({ services, heading, desc, hireDeveloperPage, isLink }) => (
  <section
    className={`lg:pt-[100px] sm:pt-16 pt-12 lg:pb-[100px] sm:pb-16 pb-12 lg:px-7 px-5 ${
      hireDeveloperPage ? "bg-gray-100" : ""
    }`}
  >
    <div className="container max-w-7xl mx-auto">
      <h2
        className={`lg:text-[44px] sm:text-[40px] text-3xl font-semibold text-gray-900 leading-tight max-w-[510px] ${
          hireDeveloperPage ? "max-w-[601px]" : ""
        }`}
      >
        {heading}
      </h2>
      <p
        className={`mt-5 text-lg leading-[29px] text-gray-700 max-w-[510px] py-px ${
          hireDeveloperPage ? "block" : "hidden"
        }`}
      >
        {desc}
      </p>
      <div className="lg:mt-[60px] sm:mt-10 mt-7 grid lg:grid-cols-3 sm:grid-cols-2 gap-x-10 lg:gap-y-[60px] gap-y-10">
        {services?.map((service, index) => (
          <ServiceCard
            key={index}
            number={index + 1}
            {...service}
            isLink={service.url ? true : isLink}
          />
        ))}
      </div>
    </div>
  </section>
);
export default Services;
